import React, { ComponentProps } from 'react';
import IForm from '../../../types/IForm';
import Form, { FormTemplate } from '../../../components/molecules/Form/Form';
import FormsRow from '../../../components/molecules/Form/components/FormsRow/FormsRow';
import FormCheckbox from '../../../components/molecules/Form/components/FormCheckbox/FormCheckbox';
import LiveRegion from '../../../components/atoms/LiveRegion/LiveRegion';
import { InteractionStatus } from '../../../types/InteractionStatus';
import { FormUtils } from '../../../components/molecules/Form';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useDelayed } from '../../../hooks/useDelayed';
import { useRefreshBlockInDefaultView } from '../../../_lib/BlockFetcher';
import { FormSubmitButton } from '../../../components/molecules/Form/components/FormSubmitButton/FormSubmitButton';

type EditViewProps = { form: IForm };

function CommentsEdit({ form }: EditViewProps) {
  const { refresh } = useRefreshBlockInDefaultView();
  const delayedRefresh = useDelayed(refresh);
  const { t } = useSonTranslation('CommentsBlock');
  const statusMessages = () => {
    return {
      [InteractionStatus.SUCCESS]: FormUtils.createStatusMessage(t('edit.status.success')),
      [InteractionStatus.SENDING]: FormUtils.createStatusMessage(t('edit.status.sending')),
      [InteractionStatus.FAIL]: FormUtils.createStatusMessage(t('edit.status.fail')),
    };
  };

  return (
    <Form id="comments-form" model={form} onSuccess={delayedRefresh}>
      <FormTemplate>
        {({ inputs, getStatus, submitActionEnabled }) => {
          return (
            <>
              <FormsRow>
                <p>{t('edit.explainingText')}</p>
              </FormsRow>
              <FormsRow>
                <FormCheckbox
                  id="comments-switch"
                  labelTitle={t('edit.label')}
                  name={inputs.active.name}
                  layout="switch"
                  checked={inputs.active.checked}
                  value={inputs.active.value}
                  onChange={inputs.active.onChange as any}
                />
              </FormsRow>
              <FormSubmitButton buttonLabel={t('edit.submit')} enabled={submitActionEnabled()} />
              <LiveRegion invisible={false} htmlTag="div">
                {getStatus(statusMessages())}
              </LiveRegion>
            </>
          );
        }}
      </FormTemplate>
    </Form>
  );
}

export const CommentsEditView = asFetchableView(CommentsEdit);
export type CommentsEditView = ComponentProps<typeof CommentsEditView>;
